module.exports = __webpack_public_path__ + "assets/phone_100.2fd85ac099d266c4914dcfdf805dc314.png";